import React, { useState, useEffect } from 'react';
import { ChildrenStoreData, ParentDetailType } from 'src/shared/types/src';
import { store, useAppDispatch, useAppSelector } from '../../services/store';
import { getCurrentChild, getParentDetailsData, getParentDetailsLoading, getParentDetailsSel } from 'src/shared/redux-state/src';
import ProfileBaseScreen from './ProfileBaseScreen';
import { CustomCheckbox, FullScreenLoader, ProfileImageView } from 'src/app/components';

const ParentalDetailsScreen = () => {

    const dispatch = useAppDispatch();

    const parentDetails: ParentDetailType[] = useAppSelector(getParentDetailsSel);
    const parentDetailsLoading: boolean = useAppSelector(getParentDetailsLoading);
    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);

    useEffect(() => {
        if (!parentDetails || parentDetails.length == 0) {
            dispatch(getParentDetailsData({ reduxStore: store, child: currentChild }))
        };
    }, []);

    const renderParent = (item: any, index: number) => {
        return (
            <div key={index} className='parent-details-wrap'>
                <p className='fs-12 fw-semibold text-black mg-b-0'>Parent/Carer {item?.order}</p>

                <div className='d-flex align-items-center mg-t-15'>
                    <ProfileImageView imageUrl={item?.photo} customContainerStyles='avatar-size-69' />
                    <div className='flex-1 mg-l-15 d-flex flex-wrap'>
                        {item?.permissions?.authorisedToCollect?.visible && (
                            <div className='w-100 mg-t-8'>
                                <CustomCheckbox 
                                    label={item?.permissions?.authorisedToCollect?.label} 
                                    isChecked={item?.permissions?.authorisedToCollect?.value}
                                    isCheckboxReadOnly={true}
                                    isRounded={true}
                                    customCheckboxLabelStyle='opacity-75 fs-12'
                                />
                            </div>
                        )}

                        {item?.permissions?.emergencyContact?.visible && (
                            <div className='w-100 mg-t-8'>
                                <CustomCheckbox 
                                    label={item?.permissions?.emergencyContact?.label} 
                                    isChecked={item?.permissions?.emergencyContact?.value}
                                    isCheckboxReadOnly={true}
                                    isRounded={true}
                                    customCheckboxLabelStyle='opacity-75 fs-12'
                                />
                            </div>
                        )}
                        <div className='w-100 d-flex mx-n-8 flex-wrap'>
                            {item?.permissions?.billPayer?.visible && (
                                <div className='mg-t-8 pd-x-8'>
                                    <CustomCheckbox 
                                        label={item?.permissions?.billPayer?.label} 
                                        isChecked={item?.permissions?.billPayer?.value}
                                        isCheckboxReadOnly={true}
                                        isRounded={true}
                                        customCheckboxLabelStyle='opacity-75 fs-12'
                                    />
                                </div>
                            )}

                            {item?.permissions?.parentalResponsibilities?.visible && (
                                <div className='mg-t-8 pd-x-8'>
                                    <CustomCheckbox 
                                        label={item?.permissions?.parentalResponsibilities?.label} 
                                        isChecked={item?.permissions?.parentalResponsibilities?.value}
                                        isCheckboxReadOnly={true}
                                        isRounded={true}
                                        customCheckboxLabelStyle='opacity-75 fs-12'
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {item?.name?.visible && (
                    <div className='form-group mg-t-25'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>{item?.name?.label || 'Name'}</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{item?.name?.value || ''}</div>
                    </div>
                )}

                <div className='row'>
                    {item?.mobilePhone?.visible && (
                        <div className='col-6 mg-t-25'>
                            <div className='form-group'>
                                <div className='form-label text-gray-300 mb-1 fs-12'>{item?.mobilePhone?.label || 'Mobile Phone'}</div>
                                <div className='form-control read-only-control d-flex align-items-center'>{item?.mobilePhone?.value || ''}</div>
                            </div>
                        </div>
                    )}

                    {item?.homePhone?.visible && (
                        <div className='col-6 mg-t-25'>
                            <div className='form-group'>
                                <div className='form-label text-gray-300 mb-1 fs-12'>{item?.homePhone?.label || 'Home Phone'}</div>
                                <div className='form-control read-only-control d-flex align-items-center'>{item?.homePhone?.value || ''}</div>
                            </div>
                        </div>
                    )}
                </div>

                {item?.email?.visible && (
                    <div className='form-group mg-t-25'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>{item?.email?.label || 'Email'}</div>
                        <div className='form-control read-only-control d-flex align-items-center text-break'>{item?.email?.value || ''}</div>
                    </div>
                )}

                <div className='row'>
                    {item?.dob?.visible && (
                        <div className='col-6 mg-t-25'>
                            <div className='form-group'>
                                <div className='form-label text-gray-300 mb-1 fs-12'>{item?.dob?.label || 'Date of Birth'}</div>
                                <div className='form-control read-only-control d-flex align-items-center'>{item?.dob?.value || ''}</div>
                            </div>
                        </div>
                    )}

                    {item?.relationship?.visible && (
                        <div className='col-6 mg-t-25'>
                            <div className='form-group'>
                                <div className='form-label text-gray-300 mb-1 fs-12'>{item?.relationship?.label || 'Relationship with child'}</div>
                                <div className='form-control read-only-control d-flex align-items-center'>{item?.relationship?.value || ''}</div>
                            </div>
                        </div>
                    )}
                </div>

                {item?.address?.visible && (
                    <div className='form-group mg-t-25'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>{item?.address?.label || 'Address'}</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{item?.address?.value || ''}</div>
                    </div>
                )}

                <div className='row'>
                    {item?.employer?.visible && (
                        <div className='col-6 mg-t-25'>
                            <div className='form-group'>
                                <div className='form-label text-gray-300 mb-1 fs-12'>{item?.employer?.label || 'Employer'}</div>
                                <div className='form-control read-only-control d-flex align-items-center'>{item?.employer?.value || ''}</div>
                            </div>
                        </div>
                    )}

                    {item?.department?.visible && (
                        <div className='col-6 mg-t-25'>
                            <div className='form-group'>
                                <div className='form-label text-gray-300 mb-1 fs-12'>{item?.department?.label || 'Department'}</div>
                                <div className='form-control read-only-control d-flex align-items-center'>{item?.department?.value || ''}</div>
                            </div>
                        </div>
                    )}

                </div>

                <div className='row'>

                    {item?.occupation?.visible && (
                        <div className='col-6 mg-t-25'>
                            <div className='form-group'>
                                <div className='form-label text-gray-300 mb-1 fs-12'>{item?.occupation?.label || 'Occupation'}</div>
                                <div className='form-control read-only-control d-flex align-items-center'>{item?.occupation?.value || ''}</div>
                            </div>
                        </div>
                    )}

                    {item?.keyWorker?.visible && (
                        <div className='col-6 mg-t-25'>
                            <CustomCheckbox 
                                label={item?.keyWorker?.label || 'Essential Worker (Key-worker)'} 
                                isChecked={item?.keyWorker?.value ? true : false}
                                isCheckboxReadOnly={true}
                                isRounded={true}
                                customCheckboxLabelStyle='opacity-75 fs-12'
                            />
                            {/* {item?.keyWorker?.value ? 'Checked' : 'Unchecked'}
                            <p>{item?.keyWorker?.label || 'Essential Worker (Key-worker)'}</p> */}
                        </div>
                    )}

                </div>

                {item?.workEmail?.visible && (
                    <div className='mg-t-25 form-group'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>{item?.workEmail?.label || 'Work Email'}</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{item?.workEmail?.value || ''}</div>
                    </div>
                )}

                {item?.workPhone?.visible && (
                    <div className='mg-t-25 form-group'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>{item?.workPhone?.label || 'Work Phone'}</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{item?.workPhone?.value || ''}</div>
                    </div>
                )}

                {item?.niNumber?.visible && (
                    <div className='mg-t-25 form-group'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>{item?.niNumber?.label || 'NI Number'}</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{item?.niNumber?.value || ''}</div>
                    </div>
                )}

                {item?.collectionPassword?.visible && (
                    <div className='mg-t-25 form-group'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>{item?.collectionPassword?.label || 'Collection/Security Password*'}</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{item?.collectionPassword?.value || ''}</div>
                    </div>
                )}

                <div className='row'>
                    {item?.bankAccountName?.visible && (
                        <div className='col-6 mg-t-25'>
                            <div className='form-group'>
                                <div className='form-label text-gray-300 mb-1 fs-12'>{item?.bankAccountName?.label || 'Bank Account Name'}</div>
                                <div className='form-control read-only-control d-flex align-items-center'>{item?.bankAccountName?.value || ''}</div>
                            </div>
                        </div>
                    )}

                    {item?.bankSortCode?.visible && (
                        <div className='col-6 mg-t-25'>
                            <div className='form-group'>
                                <div className='form-label text-gray-300 mb-1 fs-12'>{item?.bankSortCode?.label || 'Bank Sort code'}</div>
                                <div className='form-control read-only-control d-flex align-items-center'>{item?.bankSortCode?.value || ''}</div>
                            </div>
                        </div>
                    )}
                </div>

                {item?.bankAccountNumber?.visible && (
                    <div className='mg-t-25 form-group'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>{item?.bankAccountNumber?.label || 'Bank Account Number'}</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{item?.bankAccountNumber?.value || ''}</div>
                    </div>
                )}

            </div>
        )
    };

    return (
        <ProfileBaseScreen>
            {parentDetailsLoading ? <FullScreenLoader /> : <>
                {parentDetails.map((item, index) => {
                    return renderParent(item, index)
                })}
            </>}
        </ProfileBaseScreen>
    )
};

export default ParentalDetailsScreen;